export const communityLabels = [
  {
    community_id: 0,
    community_label: 'News Aggregators & Options Vol Traders',
  },
  {
    community_id: 1,
    community_label: 'Price Action Scalpers & Community Builders',
  },
  {
    community_id: 2,
    community_label: 'DeFi Innovators & Altchain Pioneers',
  },
  {
    community_id: 3,
    community_label: 'Narrative Spotters & Event-Driven Speculators',
  },
  {
    community_id: 4,
    community_label: 'Chinese Whale Networks & CEX Promoters',
  },
  {
    community_id: 5,
    community_label: 'L2 Infrastructure & Liquidity Providers',
  },
  {
    community_id: 6,
    community_label: 'Veteran Chartists & Leverage Apes',
  },
  {
    community_id: 7,
    community_label: 'Memecoin Hunters & High-Risk Investors',
  },
  {
    community_id: 8,
    community_label: 'Crypto-Native Traders & Alpha Groups',
  },
  {
    community_id: 9,
    community_label: 'Chinese Exchange Affiliates & Airdrop Farmers',
  },
  {
    community_id: 10,
    community_label: 'Ordinals Pioneers & Meme Experimenters',
  },
  {
    community_id: 11,
    community_label: 'Bitcoin Miners & Podcast Evangelists',
  },
  {
    community_id: 12,
    community_label: 'Ethereum Veterans & VC Institutions',
  },
  {
    community_id: 13,
    community_label: 'Bitcoin Sentiment Trackers & Wallet Providers',
  },
  {
    community_id: 14,
    community_label: 'Solana Founders & Ecosystem Accelerators',
  },
  {
    community_id: 15,
    community_label: 'Sarcastic Traders & Crypto Satirists',
  },
  {
    community_id: 16,
    community_label: 'Policy Advocates & Regulatory Insiders',
  },
  {
    community_id: 17,
    community_label: 'DeFi Founders & Venture Capitalists',
  },
  {
    community_id: 18,
    community_label: 'NFT Collectors & Digital Artists',
  },
  {
    community_id: 19,
    community_label: 'Ethereum Protocols & Infrastructure Builders',
  },
  {
    community_id: 20,
    community_label: 'Celebrity Athletes & Entertainment Degens',
  },
  {
    community_id: 21,
    community_label: 'Mainstream Media & Institutional Voices',
  },
  {
    community_id: 22,
    community_label: 'Memecoin Influencers & Solana Traders',
  },
  {
    community_id: 23,
    community_label: 'Onchain Hunters & Degen Callers',
  },
  {
    community_id: 24,
    community_label: 'Neo Tokyo Citizens & Web3 Gamers',
  },
  {
    community_id: 25,
    community_label: 'DeFi Founders & Onchain Analysts',
  },
  {
    community_id: 26,
    community_label: 'AI Integrators & Protocol Developers',
  },
  {
    community_id: 27,
    community_label: 'RWA Pioneers & Tokenization Experts',
  },
  {
    community_id: 28,
    community_label: 'Gaming Guilds & Play-to-Earn Enthusiasts',
  },
  {
    community_id: 29,
    community_label: ' zk Tech Researchers & Privacy Advocates',
  },
  {
    community_id: 30,
    community_label: 'Korean NFT Artists & Collector Networks',
  },
  {
    community_id: 31,
    community_label: 'Korean Airdrop Hunters & Project Promoters',
  },
  {
    community_id: 32,
    community_label: 'Institutional VCs & Crypto Fund Managers',
  },
  {
    community_id: 33,
    community_label: 'a16z Partners & Ecosystem Visionaries',
  },
  {
    community_id: 34,
    community_label: 'Bankless Hosts & Ethereum Educators',
  },
  {
    community_id: 35,
    community_label: 'Ethereum Foundation Researchers & Core Devs',
  },
  {
    community_id: 36,
    community_label: 'ConsenSys Builders & Enterprise Ethereum',
  },
  {
    community_id: 37,
    community_label: 'Coinbase Leadership & Exchange Strategists',
  },
  {
    community_id: 38,
    community_label: 'Retail Traders & Meme Momentum Chasers',
  },
  {
    community_id: 39,
    community_label: 'DeFi Protocol Advisors & Onchain Degens',
  },
  {
    community_id: 40,
    community_label: 'Prediction Market Speculators & Political Wagerers',
  },
  {
    community_id: 41,
    community_label: 'Modular DA Layers & Restaking Architects',
  },
  {
    community_id: 42,
    community_label: 'Bitcoin Ordinals & Runes Innovators',
  },
  {
    community_id: 43,
    community_label: 'Bitcoin Maxis & Sovereignty Advocates',
  },
  {
    community_id: 44,
    community_label: 'Solana Founders & High-Speed Chain Builders',
  },
  {
    community_id: 45,
    community_label: 'NFT Marketplace Pioneers & Collector Curators',
  },
  {
    community_id: 46,
    community_label: 'Ethereum Foundation Devs & Protocol Stewards',
  },
  {
    community_id: 47,
    community_label: 'Emerging L1 Innovators & AI Onchain Explorers',
  },
  {
    community_id: 48,
    community_label: 'Memecoin Maniacs & Cultural Narrative Riders',
  },
  {
    community_id: 49,
    community_label: 'ZK Circuit Crafters & Proof System Innovators',
  },
  {
    community_id: 50,
    community_label: 'Russian TON Builders & Telegram Ecosystem Hustlers',
  },
  {
    community_id: 51,
    community_label: 'NFT OGs & Digital Collectible Curators',
  },
  {
    community_id: 52,
    community_label: 'Cosmos Interchain Architects & Atom Stakers',
  },
  {
    community_id: 53,
    community_label: 'Japanese Crypto Locals & Regional News Aggregators',
  },
  {
    community_id: 54,
    community_label: 'Anarcho-Privacy Devs & DarkFi Revolutionaries',
  },
  {
    community_id: 55,
    community_label: 'Solana Infrastructure Builders & MEV Strategists',
  },
  {
    community_id: 56,
    community_label: 'Onchain Data Pioneers & Ethereum Storytellers',
  },
  {
    community_id: 57,
    community_label: 'AI-Crypto Fusion Builders & Protocol Investors',
  },
  {
    community_id: 58,
    community_label: 'NFT Liquidity Providers & Gaming Innovators',
  },
  {
    community_id: 59,
    community_label: 'Venture Capital Scouts & Fund Stewards',
  },
  {
    community_id: 60,
    community_label: 'DeFi Protocol Architects & Yield Optimizers',
  },
  {
    community_id: 61,
    community_label: 'Blockchain Researchers & Tech Visionaries',
  },
  {
    community_id: 62,
    community_label: 'Onchain Traders & Market Forecasters',
  },
  {
    community_id: 63,
    community_label: 'Quant Strategists & Flow Traders',
  },
  {
    community_id: 64,
    community_label: 'Web3 Accelerators & Founder Support Networks',
  },
  {
    community_id: 65,
    community_label: 'DeFi Innovators & Research Analysts',
  },
  {
    community_id: 66,
    community_label: 'AI-Crypto Fusion Pioneers & Tech Visionaries',
  },
  {
    community_id: 67,
    community_label: 'RWA Enthusiasts & Token Economy Designers',
  },
  {
    community_id: 68,
    community_label: 'Gaming DAOs & Metaverse Creators',
  },
  {
    community_id: 69,
    community_label: 'ZK Proofs & Scaling Researchers',
  },
  {
    community_id: 70,
    community_label: 'Layer2 Protocols & Infrastructure Devs',
  },
  {
    community_id: 71,
    community_label: 'Chinese CT Whales & Exchange Affiliates',
  },
  {
    community_id: 72,
    community_label: 'Mainstream Finance Broadcasters & Regulatory Sentinels',
  },
  {
    community_id: 73,
    community_label: 'Crypto Journalists & Investigative Reporters',
  },
  {
    community_id: 74,
    community_label: 'Institutional Investors & Wall Street Crossovers',
  },
  {
    community_id: 75,
    community_label: 'Bitcoin ETF Proponents & Asset Managers',
  },
  {
    community_id: 76,
    community_label: 'Policy Makers & Legislative Advocates',
  },
  {
    community_id: 77,
    community_label: 'Financial Analysts & Market Commentators',
  },
  {
    community_id: 78,
    community_label: 'Crypto Legal Experts & Compliance Gurus',
  },
  {
    community_id: 79,
    community_label: 'DeFi Mechanism Designers & Yield Strategists',
  },
  {
    community_id: 80,
    community_label: 'Bitcoin Ordinals Builders & Conspiracy Vibers',
  },
  {
    community_id: 81,
    community_label: 'Leverage Degens & Derivatives Pioneers',
  },
  {
    community_id: 82,
    community_label: 'Solana Meme Hunters & Narrative Riders',
  },
  {
    community_id: 83,
    community_label: 'Ethereum Layer2 Architects & Scaling Optimists',
  },
  {
    community_id: 84,
    community_label: 'AI-Crypto Fusionists & Protocol Experimenters',
  },
  {
    community_id: 85,
    community_label: 'NFT Collectors & Digital Art Curators',
  },
  {
    community_id: 86,
    community_label: 'DeFi Yield Farmers & Liquidity Providers',
  },
  {
    community_id: 87,
    community_label: 'Veteran Chartists & Bitcoin OGs',
  },
  {
    community_id: 88,
    community_label: 'Consumer Tech Founders & Crypto VCs',
  },
  {
    community_id: 89,
    community_label: 'AI Protocol Builders & Narrative Shapers',
  },
  {
    community_id: 90,
    community_label: 'NFT Ecosystem Curators & Digital Collectors',
  },
  {
    community_id: 91,
    community_label: 'DeFi Innovators & Yield Optimizers',
  },
  {
    community_id: 92,
    community_label: 'Layer1 Pioneers & Chain Maximalists',
  },
  {
    community_id: 93,
    community_label: 'Gaming Web3 Devs & Play2Earn Advocates',
  },
  {
    community_id: 94,
    community_label: 'Privacy Tech Researchers & ZK Enthusiasts',
  },
  {
    community_id: 95,
    community_label: 'Fintwit Satirists & Market Shitposters',
  },
  {
    community_id: 96,
    community_label: 'Tech Visionaries & Freedom Tech Advocates',
  },
  {
    community_id: 97,
    community_label: 'Ethereum Core Devs & Protocol Architects',
  },
  {
    community_id: 98,
    community_label: 'Elon Musk Disciples & Dogecoin Degens',
  },
  {
    community_id: 99,
    community_label: 'FTX Alumni & Regulatory Watchdogs',
  },
  {
    community_id: 100,
    community_label: 'Binance Empire & CEX Power Players',
  },
  {
    community_id: 101,
    community_label: 'Solana Meme Pumpers & Launchpad Hustlers',
  },
  {
    community_id: 102,
    community_label: 'AI Narrative Shapers & Future Tech Prophets',
  },
  {
    community_id: 103,
    community_label: 'Korean VC Networks & Asia-Pacific Builders',
  },
  {
    community_id: 104,
    community_label: 'DeFi Quant Wizards & Protocol Sleuths',
  },
  {
    community_id: 105,
    community_label: 'SKALE Chain Builders & Modular Enthusiasts',
  },
  {
    community_id: 106,
    community_label: 'Liquid Staking Architects & Lido Maximalists',
  },
  {
    community_id: 107,
    community_label: 'Perps Traders & dYdX Power Users',
  },
  {
    community_id: 108,
    community_label: 'ZK Validity Proofs & StarkWare Pioneers',
  },
  {
    community_id: 109,
    community_label: 'Onchain Degens & Chaos Theorists',
  },
  {
    community_id: 110,
    community_label: 'Podcast Hosts & Lightspeed Narrators',
  },
  {
    community_id: 111,
    community_label: 'Loot Adventurers & Early DAO Visionaries',
  },
  {
    community_id: 112,
    community_label: 'Cosmos DeFi Innovators & Interchain Liquidity Crafters',
  },
  {
    community_id: 113,
    community_label: 'TRON Chain Maximalists & Justin Sun Orbiters',
  },
  {
    community_id: 114,
    community_label: 'Bitcoin News Amplifiers & Conference Evangelists',
  },
  {
    community_id: 115,
    community_label: 'Altcoin Signal Callers & Chart Pattern Hunters',
  },
  {
    community_id: 116,
    community_label: 'Web3 UX Designers & Product Aestheticians',
  },
  {
    community_id: 117,
    community_label: 'Solana Meme Crafters & Degen Vibesetters',
  },
  {
    community_id: 118,
    community_label: 'Perpetual Futures Degens & Leverage Maximalists',
  },
  {
    community_id: 119,
    community_label: 'Memecoin Egregores & Retardio Summoners',
  },
  {
    community_id: 120,
    community_label: 'Farcaster Founders & Decentralized Social Visionaries',
  },
  {
    community_id: 121,
    community_label: 'AI-Crypto Integrators & Machine Learning Mavericks',
  },
  {
    community_id: 122,
    community_label: 'NFT Marketplace OGs & Art Token Curators',
  },
  {
    community_id: 123,
    community_label: 'DeFi Yield Chasers & Liquidity Wizards',
  },
  {
    community_id: 124,
    community_label: 'Layer Zero Interop Builders & Cross-Chain Pioneers',
  },
  {
    community_id: 125,
    community_label: 'Privacy Coin Advocates & Anonymity Protocol Devs',
  },
  {
    community_id: 126,
    community_label: 'Web3 Gaming Guilds & P2E Strategists',
  },
  {
    community_id: 127,
    community_label: 'Solana Core Devs & High-Throughput Chain Builders',
  },
  {
    community_id: 128,
    community_label: 'Chinese CT Whales & Exchange Affiliates',
  },
  {
    community_id: 129,
    community_label: 'Ordinals Inscribers & Bitcoin NFT Pioneers',
  },
  {
    community_id: 130,
    community_label: 'Solana Founders & Core Chain Stewards',
  },
  {
    community_id: 131,
    community_label: 'Solana Memecoin Pumpers & DEX Screener Degens',
  },
  {
    community_id: 132,
    community_label: 'Korean Blockchain Builders & Klaytn Loyalists',
  },
  {
    community_id: 133,
    community_label: 'TON Ecosystem Crafters & Telegram Integrators',
  },
  {
    community_id: 134,
    community_label: 'Russian TON Advocates & Wallet Innovators',
  },
  {
    community_id: 135,
    community_label: 'Solana Superteams & Global Community Forgers',
  },
  {
    community_id: 136,
    community_label: 'Doodles Vibers & NFT Community Stewards',
  },
  {
    community_id: 137,
    community_label: 'Claynosaurz Creators & Digital Dino Enthusiasts',
  },
  {
    community_id: 138,
    community_label: 'Pudgy Penguins OGs & Iceberg Degens',
  },
  {
    community_id: 139,
    community_label: 'Azuki Garden Keepers & Bean Cultivators',
  },
  {
    community_id: 140,
    community_label: 'BAYC Apes & Yacht Club Socialites',
  },
  {
    community_id: 141,
    community_label: 'NFT Analysts & Market Whisperers',
  },
  {
    community_id: 142,
    community_label: 'Web3 Collectors & Art Curators',
  },
  {
    community_id: 143,
    community_label: 'NFT Hype Masters & Project Evangelists',
  },
  {
    community_id: 144,
    community_label: 'Cosmos Interchain Pioneers & IBC Connectors',
  },
  {
    community_id: 145,
    community_label: 'Evmos EVM-Cosmos Bridge Builders & dApp Explorers',
  },
  {
    community_id: 146,
    community_label: 'Osmosis Liquidity Swappers & Grant Seekers',
  },
  {
    community_id: 147,
    community_label: 'Atom Stakers & Hub Governance Participants',
  },
  {
    community_id: 148,
    community_label: 'Interchain Security Providers & Validator Networks',
  },
  {
    community_id: 149,
    community_label: 'Cosmos SDK Devs & Custom Chain Creators',
  },
  {
    community_id: 150,
    community_label: 'Stargaze NFT Artists & Cosmos Creatives',
  },
  {
    community_id: 151,
    community_label: 'Tech Startup Founders & Venture Innovators',
  },
  {
    community_id: 152,
    community_label: 'Azuki Elementalists & NFT Lore Keepers',
  },
  {
    community_id: 153,
    community_label: 'CyberKongz Vault Dwellers & Play2Earn Apes',
  },
  {
    community_id: 154,
    community_label: 'Goblintown Grifters & Meme NFT Degens',
  },
  {
    community_id: 155,
    community_label: 'Memeland Captains & Humor-Driven Collectors',
  },
  {
    community_id: 156,
    community_label: 'Forbes Web3 Elites & Media Integrators',
  },
  {
    community_id: 157,
    community_label: 'Keungz Visionaries & Ecosystem Builders',
  },
  {
    community_id: 158,
    community_label: 'Bored Ape Yacht Clubbers & DAO Participants',
  },
  {
    community_id: 159,
    community_label: 'Bitcoin Content Alchemists & Market Mood Readers',
  },
  {
    community_id: 160,
    community_label: 'Milady Meme Architects & Remilia Revolutionaries',
  },
  {
    community_id: 161,
    community_label: 'Radbro Ringmasters & E-Acc Degens',
  },
  {
    community_id: 162,
    community_label: 'Yayo Warlords & Cult Egregores',
  },
  {
    community_id: 163,
    community_label: 'Bonkler Experimenters & Financial Art Pranksters',
  },
  {
    community_id: 164,
    community_label: 'Network State Nomads & Aura Maxis',
  },
  {
    community_id: 165,
    community_label: 'Cyber Angels & Redpilled Poets',
  },
  {
    community_id: 166,
    community_label: 'Grift Shop Proprietors & Meme Merchants',
  },
  {
    community_id: 167,
    community_label: 'Ethereum Contract Crafters & DAO Developers',
  },
  {
    community_id: 168,
    community_label: 'DAO Toolmakers & NFT Platform Pioneers',
  },
  {
    community_id: 169,
    community_label: 'Web3 Art Collectors & Gallery Curators',
  },
  {
    community_id: 170,
    community_label: 'ConsenSys Alumni & Mesh Networkers',
  },
  {
    community_id: 171,
    community_label: 'Generative Art Enthusiasts & AI Creators',
  },
  {
    community_id: 172,
    community_label: 'Onchain Oasis Builders & Tech Refugists',
  },
  {
    community_id: 173,
    community_label: 'Crypto Legal Scholars & Law Professors',
  },
  {
    community_id: 174,
    community_label: 'Venture Collaborators & Glitch Artists',
  },
  {
    community_id: 175,
    community_label: 'Crypto Gambling Tycoons & Streaming Founders',
  },
  {
    community_id: 176,
    community_label: 'BAYC Banana Peels & Chimpers Swing Set',
  },
  {
    community_id: 177,
    community_label: 'ApeCoin Vault Guardians & Yacht Club OGs',
  },
  {
    community_id: 178,
    community_label: 'Pudgy Penguins Huddle & Igloo Innovators',
  },
  {
    community_id: 179,
    community_label: 'Chimpers Dojo Masters & Primate Playgrounds',
  },
  {
    community_id: 180,
    community_label: 'Doodles Sketchbook Crew & Colorful Vibesetters',
  },
  {
    community_id: 181,
    community_label: 'Azuki Garden Keepers & Elemental Lore Weavers',
  },
  {
    community_id: 182,
    community_label: 'Claynosaurz Clay Molders & Prehistoric NFT Hunters',
  },
  {
    community_id: 183,
    community_label: 'Polymarket Prognosticators & Bet Resolution Oracles',
  },
  {
    community_id: 184,
    community_label: 'AI Art Visionaries & Generative Creators',
  },
  {
    community_id: 185,
    community_label: 'NFT Collectors & Provenance Historians',
  },
  {
    community_id: 186,
    community_label: 'Digital Pop Artists & Animation Innovators',
  },
  {
    community_id: 187,
    community_label: 'Crypto Photography Pioneers & Twin Flames Curators',
  },
  {
    community_id: 188,
    community_label: 'Vector Realism Painters & Neo-Precisionists',
  },
  {
    community_id: 189,
    community_label: 'CryptoPunk OGs & Historic NFT Stewards',
  },
  {
    community_id: 190,
    community_label: 'Muse-Guided Creators & Ethereal Dreamweavers',
  },
  {
    community_id: 191,
    community_label: 'Silicon Valley VCs & Early-Stage Alchemists',
  },
  {
    community_id: 192,
    community_label: 'Public Goods Funders & Social Token Pioneers',
  },
  {
    community_id: 193,
    community_label: 'Ethereum Founders & DeFi Originators',
  },
  {
    community_id: 194,
    community_label: 'FTX Alumni & Effective Altruists',
  },
  {
    community_id: 195,
    community_label: 'Bitcoin Corporate Adopters & Laser-Eyed Maxis',
  },
  {
    community_id: 196,
    community_label: 'Binance Ecosystem Builders & CZ Inner Circle',
  },
  {
    community_id: 197,
    community_label: 'Solana Founders & Breakpoint Regulars',
  },
  {
    community_id: 198,
    community_label: 'TRON Empire Expanders & Justin Sun Affiliates',
  },
  {
    community_id: 199,
    community_label: 'E/Acc Accelerationists & AI Optimists',
  },
  {
    community_id: 200,
    community_label: 'Digital Art Pioneers & SuperRare Curators',
  },
  {
    community_id: 201,
    community_label: 'Tezos Clean NFT Advocates & Objkt Collectors',
  },
  {
    community_id: 202,
    community_label: 'Generative Visionaries & Foundation Creators',
  },
  {
    community_id: 203,
    community_label: 'Cyberpunk Renderers & 3D World Builders',
  },
  {
    community_id: 204,
    community_label: 'Animation Alchemists & Hand-Drawn Dreamers',
  },
  {
    community_id: 205,
    community_label: 'Open Edition Rebels & 6529 Meme Lords',
  },
  {
    community_id: 206,
    community_label: 'Adversarial Artists & Experimental Explorers',
  },
  {
    community_id: 207,
    community_label: 'AI Photography Fusionists & Collector Councils',
  },
  {
    community_id: 208,
    community_label: 'Chinese Dissident Journalists & Tech Freedom Fighters',
  },
  {
    community_id: 209,
    community_label: 'Pixel Art Curators & Retro Code Poets',
  },
  {
    community_id: 210,
    community_label: 'Open Source Evangelists & Anime Enthusiasts',
  },
  {
    community_id: 211,
    community_label: 'Censorship Evaders & Great Firewall Hackers',
  },
  {
    community_id: 212,
    community_label: 'Chinese Crypto Builders & Token Experimenters',
  },
  {
    community_id: 213,
    community_label: 'Tech Forum Founders & Community Tokenizers',
  },
  {
    community_id: 214,
    community_label: 'Biotech Accelerationists & AI Diplomats',
  },
  {
    community_id: 215,
    community_label: 'PayPal Mafia Veterans & e/acc Visionaries',
  },
  {
    community_id: 216,
    community_label: 'NFT Storytellers & Coffee Podcasters',
  },
  {
    community_id: 217,
    community_label: 'BAYC Banana Holders & ApeCoin Voters',
  },
  {
    community_id: 218,
    community_label: 'Pudgy Penguins Waddlers & Igloo Builders',
  },
  {
    community_id: 219,
    community_label: 'Chimpers Tree Climbers & Pixel Ape Artists',
  },
  {
    community_id: 220,
    community_label: 'Doodles Sketchbook Dreamers & Color Vibers',
  },
  {
    community_id: 221,
    community_label: 'Azuki Elemental Summoners & Bean Cultivators',
  },
  {
    community_id: 222,
    community_label: 'Claynosaurz Clay Shapers & Jurassic Explorers',
  },
  {
    community_id: 223,
    community_label: 'Anime Waifu Creators & Manga-Inspired Minters',
  },
  {
    community_id: 224,
    community_label: 'Digital Fashion Forgers & RTFKT Creators',
  },
  {
    community_id: 225,
    community_label: 'LUKSO Lifestyle Architects & Universal Profile Pioneers',
  },
  {
    community_id: 226,
    community_label: 'NFT Athlete Integrators & Soccer Star Collectors',
  },
  {
    community_id: 227,
    community_label: '3D Studio Builders & Visual Storytellers',
  },
  {
    community_id: 228,
    community_label: 'Multiverse Pixel Dwellers & LYX Maximalists',
  },
  {
    community_id: 229,
    community_label: 'Creative Revolutionaries & Ecosystem Incubators',
  },
  {
    community_id: 230,
    community_label: 'Web3 Collectors & Degen Advisors',
  },
  {
    community_id: 231,
    community_label: 'Tech Media Scribes & Venture Storytellers',
  },
  {
    community_id: 232,
    community_label: 'Solana Digital Artists & Exchange Curators',
  },
  {
    community_id: 233,
    community_label: 'Generative Pixel Crafters & Retro Game Inspirers',
  },
  {
    community_id: 234,
    community_label: 'Nostalgic Illustrators & Joy Evokers',
  },
  {
    community_id: 235,
    community_label: 'Animation Innovators & Brand Motion Makers',
  },
  {
    community_id: 236,
    community_label: 'Milady Collectors & Pretty NFT Advocates',
  },
  {
    community_id: 237,
    community_label: 'Comic Storytellers & Vault Creators',
  },
  {
    community_id: 238,
    community_label: 'Web3 Advisors & Degen Ambassadors',
  },
  {
    community_id: 239,
    community_label: 'Doodles Space Builders & Code Vloggers',
  },
  {
    community_id: 240,
    community_label: 'Crypto Sleuths & Policy Whisperers',
  },
  {
    community_id: 241,
    community_label: 'Bitcoin Pioneers & Libertarian Shapeshifters',
  },
  {
    community_id: 242,
    community_label: 'Mainstream Crypto Chroniclers & Podcast Probes',
  },
  {
    community_id: 243,
    community_label: 'Korean Airdrop Hunters & Wallet Wizards',
  },
  {
    community_id: 244,
    community_label: 'Korean Web3 Builders & Solana Surfers',
  },
  {
    community_id: 245,
    community_label: 'Korean Chart Readers & Token Trackers',
  },
  {
    community_id: 246,
    community_label: 'Korean Crypto Beasts & Market Maulers',
  },
  {
    community_id: 247,
    community_label: 'Korean DAO Architects & Node Nomads',
  },
  {
    community_id: 248,
    community_label: 'Korean Solana Sovereigns & Eastern Chain Emperors',
  },
  {
    community_id: 249,
    community_label: 'Korean Airdrop Nomads & Wallet Wanderers',
  },
  {
    community_id: 250,
    community_label: 'Korean Chart Conjurers & Token Tale Tellers',
  },
  {
    community_id: 251,
    community_label: 'Korean Crypto Beasts & Market Maulers',
  },
  {
    community_id: 252,
    community_label: 'Korean DAO Dreamweavers & Node Navigators',
  },
  {
    community_id: 253,
    community_label: 'Urban Music Alchemists & Holistic Degen Vibers',
  },
];
